import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useAuth } from 'src/contexts/auth'
import { PregnancyDiagnosisController } from 'src/controllers/pregnancy-diagnosis.controller'
import { PregnancyDiagnosisParams } from 'src/domain/coverage-process'

const pregnancyDiagnosisController = new PregnancyDiagnosisController()

export function useCreatePregnancyDiagnosis() {
  const { userFarm: farmId } = useAuth()

  return useMutation({
    mutationKey: ['createPregnancyDiagnosis'],
    mutationFn: (pregnancyDiagnosisDto: PregnancyDiagnosisParams) =>
      pregnancyDiagnosisController.createPregnancyDiagnosis(farmId!, pregnancyDiagnosisDto),
    onError: () => {
      toast.error('Erro ao criar diagnóstico de gestação')
    }
  })
}
